import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
	BarcodeMappingGridWithGlobalCompanyPrefixModel,
	BarcodeMappingToMasterGridModel,
	ProductBarcodeAssignmentToMasterGridResultModel, ProductBarcodeMappingOption
} from '../../../shared/models/product-barcode.model';
import {ExtraFilteringOptions, LoadOptions} from '../../../shared/models/shared.model';
import {GridSetting, GridSettings, GridState, User} from '../../../shared';
import {Subject} from 'rxjs';
import {ProductBarcodeService} from '../../../api/product-barcode.service';
import {UserApi} from '../../../api';
import {FilterBuilderService} from '../../../service/filter-builder.service';
import {LoaderService} from '../../../core/loader/loader.service';
import {DragulaService} from 'ng2-dragula';
import {take, takeUntil} from 'rxjs/operators';
import CustomStore from 'devextreme/data/custom_store';
import {MappingAction, MappingMode} from '../../../shared/enum/mapping-mode.enum';
import {NotificationType} from '../../../shared/enum/notification.enum';
import {NotificationService} from '../../../service/notification.service';
import {ProductMappingToMasterGridResult} from '../../../shared/models/product.model';

@Component ({
	selector: 'app-barcode-to-product-mapping',
	templateUrl: './barcode-to-product-mapping.component.html',
})

export class BarcodeToProductMappingComponent implements OnInit, OnDestroy {
	@ViewChild('barcodeMappingGridWithGlobalCompanyPrefixGrid', {static: false}) barcodeMappingGridWithGlobalCompanyPrefixGrid: any;
	@ViewChild('barcodeMappingToMasterGrid', {static: false}) barcodeMappingToMasterGrid: any;
	@ViewChild('productBarcodeMasterGrid', {static: false}) productBarcodeMasterGrid: any;

	public productBarcodeMasterDataSource = {};
	public barcodeMappingToMasterGridDataSource: BarcodeMappingToMasterGridModel[] = [];
	public barcodeMappingGridWithGlobalCompanyPrefixGridDataSource = {};

	public extraFilteringOptions: ExtraFilteringOptions[] = [
		{ column: 'Active', value: false },
	];
	public productBarcodeMasterGridSelectedRowMap = [];
	public barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap: any;
	public currentUser: User;

	// Mapping Gird header filter
	sourceBarcodeHeaderDataSource: any;
	cleanBarcodeHeaderDataSource: any;
	globalCompanyPrefixHeaderDataSource: any;
	mappingPriorityHeaderDataSource: any;
	mappingAssignedToUserIdHeaderDataSource: any;
	productBarcodeMappingsCountHeaderDataSource: any;
	productBarcodeIdHeaderDataSource: any;
	quantityMultiplierHeaderDataSource: any;
	productBarcodeIsActiveHeaderDataSource: any;
	productMasterIdHeaderDataSource: any;
	companyIdHeaderDataSource: any;
	companyNameMappingHeaderDataSource: any;
	masterBrandIdHeaderDataSource: any;
	masterBrandNameHeaderDataSource: any;
	brandIdHeaderDataSource: any;
	brandNameMappingHeaderDataSource: any;
	subBrandIdHeaderDataSource: any;
	subBrandNameMappingHeaderDataSource: any;
	productIdHeaderDataSource: any;
	productNameMappingHeaderDataSource: any;
	productIsNatureInspiredHeaderDataSource: any;
	productIsMensProductHeaderDataSource: any;
	productIsDiscontinuedHeaderDataSource: any;
	categoryIdHeaderDataSource: any;
	categoryNameMappingHeaderDataSource: any;
	subcategoryFormIdHeaderDataSource: any;
	subcategoryFormNameMappingHeaderDataSource: any;
	subcategoryFunctionIdHeaderDataSource: any;
	subcategoryFunctionNameMappingHeaderDataSource: any;
	productSizeOnLabelMappingHeaderDataSource: any;
	packagingTypeIdHeaderDataSource: any;
	packagingTypeNameHeaderDataSource: any;
	productMasterIsDiscontinuedHeaderDataSource: any;
	productMasterIsActiveHeaderDataSource: any;
	inconsistentServiceAndProductMappingsCountHeaderDataSource: any;
	createdOnHeaderDataSource: any;
	createdByUserFullNameSortableOrPrincipalNameHeaderDataSource: any;
	modifiedOnHeaderDataSource: any;
	modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource: any;
	reviewedOnHeaderDataSource: any;
	reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource: any;

	public isLoadProductBarcodeMasterDataSource: boolean;
	public isLoadBarcodeMappingGridWithGlobalCompanyPrefixGridSource: boolean;
	companyNameHeaderDataSource;
	masterBrandHeaderDataSource;
	brandNameHeaderDataSource;
	subBrandNameHeaderDataSource;
	productNameHeaderDataSource;
	categoryNameHeaderDataSource;
	subcategoryFunctionNameHeaderDataSource;
	subcategoryFormNameHeaderDataSource;
	productSizeOnLabelHeaderDataSource;

	private _destroyed$ = new Subject();
	private isProductBarcodeMasterLoading = false;
	private isBarcodeMappingGridWithGlobalCompanyPrefixGridLoading = false;

	private readonly mappingGridName: string = 'barcodeMappingGridWithGlobalCompanyPrefixGrid';
	private readonly masterGridName: string = 'productBarcodeMasterGrid';
	private readonly pageName: string = 'barcodeMapping';
	private currentProductBarcodeMasterDataGridState: GridState;
	private currentBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState: GridState;
	private productBarcodeMasterDataGridSettings: GridSettings;
	private barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettings: GridSettings;
	private isProductBarcodeMasterDataGridSettingLoading = true;
	private isBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettingLoading = true;
	private productBarcodeMasterDataGridSetting: GridSetting = new GridSetting();
	private barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting: GridSetting = new GridSetting();
	private productBarcodeMasterCurrentPage: number;
	private barcodeMappingGridWithGlobalCompanyPrefixGridCurrentPage: any;
	private isProductBarcodeAssignmentToMasterGridLoading: boolean;
	private isMoveToNextRow: boolean;
	private barcodeMappingSelectedRowIndex: number;

	constructor(
		private productBarcodeService: ProductBarcodeService,
		private userService: UserApi,
		private filterBuilder: FilterBuilderService,
		private loaderService: LoaderService,
		public dragulaService: DragulaService,
		private notificationService: NotificationService,
	) {
		dragulaService.createGroup('HANDLES3', {
			moves: (el, container, handle) => {
				return handle.className === 'fa fa-arrows';
			}
		});
	}

	ngOnInit() {
		this.loaderService.show();
		this.currentUser = this.userService.logonUser;
		if (!this.currentUser) {
			return;
		}

		this.productBarcodeMasterDataGridSettings = {
			PageName: this.pageName,
			GridName: this.mappingGridName,
			OwnedByUserId: this.currentUser.UserId
		};

		this.userService.getGridSettings(this.productBarcodeMasterDataGridSettings)
			.pipe(take(1))
			.subscribe((settings) => {
				if (settings && settings.Settings) {
					if (typeof settings.Settings === 'string') {
						this.productBarcodeMasterDataGridSetting = JSON.parse(settings.Settings);
					} else {
						this.productBarcodeMasterDataGridSetting = settings.Settings;
					}
				} else {
					this.productBarcodeMasterDataGridSettings.Settings = JSON.stringify({autosave: true});
					this.updateGridSettings(this.productBarcodeMasterDataGridSettings);
				}
				this.loadProductBarcodeMasterDataGridState();
			});
		this.loadBarcodeMappingHeaderFilterData();

		this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettings = {
			PageName: this.pageName,
			GridName: this.masterGridName,
			OwnedByUserId: this.currentUser.UserId
		};

		this.userService.getGridSettings(this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettings)
			.pipe(take(1))
			.subscribe((settings) => {
				if (settings && settings.Settings) {
					if (typeof settings.Settings === 'string') {
						this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting = JSON.parse(settings.Settings);
					} else {
						this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting = settings.Settings;
					}
				} else {
					this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettings.Settings = JSON.stringify({autosave: true});
					this.updateGridSettings(this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettings);
				}
				this.loadBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState();
			});
		this.loadMasterColumnHeaderFilterData();
	}

	onRowExpanding(e: any) {
		e.component.collapseAll(-1);
	}

	onRowExpanded(e: any) {
		e.component.selectRows([e.key]);
	}

	private loadBarcodeMappingHeaderFilterData() {
		this.sourceBarcodeHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SourceBarcode';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.cleanBarcodeHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CleanBarcode';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.globalCompanyPrefixHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'GlobalCompanyPrefix';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.mappingPriorityHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'MappingPriority';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.mappingAssignedToUserIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'MappingAssignedToUserId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.productBarcodeMappingsCountHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductBarcodeMappingsCount';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.productBarcodeIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductBarcodeId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.quantityMultiplierHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'QuantityMultiplier';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.productBarcodeIsActiveHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductBarcodeIsActive';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.productMasterIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductMasterId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.companyIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CompanyId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.companyNameMappingHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CompanyName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.masterBrandIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'MasterBrandId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

		this.masterBrandNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'MasterBrandName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.brandIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'BrandId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.brandNameMappingHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'BrandName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.subBrandIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubBrandId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.subBrandNameMappingHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubBrandName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.productIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.productNameMappingHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.productIsNatureInspiredHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductIsNatureInspired';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.productIsMensProductHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductIsMensProduct';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.productIsDiscontinuedHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductIsDiscontinued';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.categoryIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CategoryId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.categoryNameMappingHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CategoryName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.subcategoryFormIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubcategoryFormId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.subcategoryFormNameMappingHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubcategoryFormName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.subcategoryFunctionIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubcategoryFunctionId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.subcategoryFunctionNameMappingHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubcategoryFunctionName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.productSizeOnLabelMappingHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductSizeOnLabel';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.packagingTypeIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'PackagingTypeId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.packagingTypeNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'PackagingTypeName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.productMasterIsDiscontinuedHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductMasterIsDiscontinued';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.productMasterIsActiveHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductMasterIsActive';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.inconsistentServiceAndProductMappingsCountHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'InconsistentServiceAndProductMappingsCount';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.createdOnHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CreatedOn';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.createdByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CreatedByUserFullNameSortableOrPrincipalName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.modifiedOnHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ModifiedOn';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ModifiedByUserFullNameSortableOrPrincipalName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.reviewedOnHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ReviewedOn';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

this.reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ReviewedByUserFullNameSortableOrPrincipalName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersBarcodeMapping(loadOptions);
			}
		});

	}

	private updateGridSettings(gridSettings: GridSettings) {
		gridSettings.SavedOn = new Date();
		this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
	}

	private updateGridState(gridState: GridState) {
		gridState.SavedOn = new Date();
		this.userService.setGridState(gridState).pipe(take(1)).subscribe();
	}

	private loadBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState() {
		this.userService.getGridState(this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettings)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((state) => {
				if (state) {
					this.currentBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState = state;
				} else {
					this.currentBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState = {
						PageName: this.pageName,
						GridName: this.masterGridName,
						OwnedByUserId: this.currentUser.UserId,
						State: null
					};
				}
				this.loadBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridSource();
			});
	}

	private loadProductBarcodeMasterDataGridState() {
		this.userService.getGridState(this.productBarcodeMasterDataGridSettings)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((state) => {
				if (state) {
					this.currentProductBarcodeMasterDataGridState = state;
				} else {
					this.currentProductBarcodeMasterDataGridState = {
						PageName: this.pageName,
						GridName: this.mappingGridName,
						OwnedByUserId: this.currentUser.UserId,
						State: null
					};
				}
				this.loadProductBarcodeMasterDataSource();
			});
	}

	private loadProductBarcodeMasterDataSource() {
		this.isProductBarcodeMasterDataGridSettingLoading = false;
		this.productBarcodeMasterDataSource = new CustomStore({
			key: 'ProductBarcodeId',
			load: (loadOptions: any) => {
				this.isProductBarcodeMasterLoading = true;
				this.loaderService.show();
				const filter = this.formatFilterOperators(loadOptions.filter);
				const finalOptions: LoadOptions = loadOptions;
				finalOptions.filter = filter;

				return this.productBarcodeService.getProductBarcodeMasterGrid(finalOptions)
					.toPromise()
					.then((data: any) => {
						this.isProductBarcodeMasterLoading = false;
						this.loaderHandler();
						return {
							data: data.data,
							totalCount: data.totalCount,
							summary: data.summary,
							groupCount: data.groupCount
						};
					})
					.catch(error => {
						this.isProductBarcodeMasterLoading = false;
						this.loaderHandler();
						throw new Error('Data Loading Error');
					});
			}
		});
		this.isLoadProductBarcodeMasterDataSource = true;
	}

	// public getProductBarcodeAssignmentToMasterGridData(ProductBarcodeId: number) {
	// 	if (!ProductBarcodeId) {
	// 		return;
	// 	}
	// 	this.isProductBarcodeAssignmentToMasterGridLoading = true;
	// 	this.loaderService.show();
	// 	this.productBarcodeService.getGetProductBarcodeAssignmentToMasterGridResult(ProductBarcodeId)
	// 		.pipe(take(1))
	// 		.subscribe((data) => {
	// 			this.isProductBarcodeAssignmentToMasterGridLoading = false;
	// 			this.loaderHandler();
	// 			this.barcodeMappingToMasterGridDataSource = data;
	// 			// this.productBarcodeAssignmentToMasterGrid.instance.option('dataSource', data);
	// 		});
	// }

	private loadBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridSource() {
		this.isBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettingLoading = false;
		this.barcodeMappingGridWithGlobalCompanyPrefixGridDataSource = new CustomStore({
			key: 'BarcodeMappingId',
			load: (loadOptions: any) => {
				this.isBarcodeMappingGridWithGlobalCompanyPrefixGridLoading = true;
				this.loaderService.show();
				const filter = this.formatFilterOperators(loadOptions.filter);
				const finalOptions: LoadOptions = loadOptions;
				finalOptions.filter = filter;

				return this.productBarcodeService.getBarcodeMappingGridWithGlobalCompanyPrefixResult(finalOptions)
					.toPromise()
					.then((data: any) => {
						this.isBarcodeMappingGridWithGlobalCompanyPrefixGridLoading = false;
						this.loaderHandler();
						if (this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap) {
							const matchedData = data.data.find(item =>
								item.BarcodeMappingId === this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.BarcodeMappingId);
							this.isMoveToNextRow = !!matchedData;
						}
						if (!data.data || data.data.length === 0) {
							this.barcodeMappingToMasterGridDataSource = [];
						}
						this.getBarcodeMappingToMasterGridData
						(data.data.BarcodeMappingId);
						return {
							data: data.data,
							totalCount: data.totalCount,
							summary: data.summary,
							groupCount: data.groupCount
						};
					})
					.catch(error => {
						this.isBarcodeMappingGridWithGlobalCompanyPrefixGridLoading = false;
						this.loaderHandler();
						throw new Error('Data Loading Error');
					});
			}
		});
		this.isLoadBarcodeMappingGridWithGlobalCompanyPrefixGridSource = true;
	}

	onReady(e) {
		const grid = e.component;
		const selection = grid.getSelectedRowKeys();
		if (this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap) {
			const currentDataItems = this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.getDataSource().items();
			const matchedData = currentDataItems.find(item =>
			item.BarcodeMappingId === this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.BarcodeMappingId);
			if (!matchedData && this.barcodeMappingGridWithGlobalCompanyPrefixGridCurrentPage
				!== this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.pageIndex()) {
				grid.selectRowsByIndexes([0]);
			}
		}
		if (selection.length === 0) {
			grid.selectRowsByIndexes([0]);
		} else {
			if (this.isMoveToNextRow && this.isNextRowAvailable) {
				this.moveToNextRow();
				this.isMoveToNextRow = false;
			} else {
				this.stayInRow();
			}
		}
	}

	private moveToNextRow() {
		this.setProductMappingSelectedRowIndex();
		this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.selectRowsByIndexes([this.barcodeMappingSelectedRowIndex + 1]);
	}

	private stayInRow() {
		this.setProductMappingSelectedRowIndex();
		this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.selectRowsByIndexes([this.barcodeMappingSelectedRowIndex]);
	}

	private setProductMappingSelectedRowIndex() {
		const selectedRowKey = this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.BarcodeMappingId;
		const barcodeMappingSelectedRowIndex = this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.getRowIndexByKey(selectedRowKey);
		this.barcodeMappingSelectedRowIndex = barcodeMappingSelectedRowIndex >= 0 ?
			barcodeMappingSelectedRowIndex : this.barcodeMappingSelectedRowIndex;
	}

	private get isNextRowAvailable() {
		const barcodeMappingRowData =
			this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.getRowElement(this.barcodeMappingSelectedRowIndex + 1);
		return !!barcodeMappingRowData;
	}

	public loadProductBarcodeMasterState = () => {
		return this.currentProductBarcodeMasterDataGridState.State ? JSON.parse(this.currentProductBarcodeMasterDataGridState.State) : null;
	}

	public saveProductBarcodeMasterState = (state: any) => {
		if (this.productBarcodeMasterDataGridSetting) {
			let gridSetting: GridSetting;
			if (typeof this.productBarcodeMasterDataGridSetting === 'string') {
				gridSetting = JSON.parse(this.productBarcodeMasterDataGridSetting);
			} else {
				gridSetting = this.productBarcodeMasterDataGridSetting;
			}
			if (gridSetting.autosave) {
				this.currentProductBarcodeMasterDataGridState.State = JSON.stringify(state);
				this.updateGridState(this.currentProductBarcodeMasterDataGridState);
			}
		}
	}

	public loadBarcodeMappingGridWithGlobalCompanyPrefixGridState = () => {
		return this.currentBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState.State ?
			JSON.parse(this.currentBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState.State) :
			null;
	}

	public saveBarcodeMappingGridWithGlobalCompanyPrefixGridState = (state: any) => {
		if (this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting) {
			let gridSetting: GridSetting;
			if (typeof this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting === 'string') {
				gridSetting = JSON.parse(this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting);
			} else {
				gridSetting = this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting;
			}
			if (gridSetting.autosave) {
				this.currentBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState.State = JSON.stringify(state);
				this.updateGridState(this.currentBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridState);
			}
		}
	}


	public productBarcodeMasterDataGridContextMenu(e) {
		if (e.target === 'content') {
			// e.items can be undefined
			if (!e.items) { e.items = []; }

			// Add a custom menu item
			e.items.push(
				{
					text: 'Refresh',
					icon: 'refresh',
					onItemClick: () => {
						this.refreshProductBarcodeMasterDataGrid();
					}
				},
				{
					text: 'Grid Settings',
					items: [
						{
							text: this.productBarcodeMasterDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
							onItemClick: () => {
								this.productBarcodeMasterDataGridSetting.autosave = !this.productBarcodeMasterDataGridSetting.autosave;
								this.productBarcodeMasterDataGridSettings.Settings = JSON.stringify(this.productBarcodeMasterDataGridSetting);
								this.updateGridSettings(this.productBarcodeMasterDataGridSettings);
							}
						},
						{
							text: 'Reset to Default',
							onItemClick: () => {
								this.userService.resetDataGridStateToDefault(this.mappingGridName, this.pageName, this.currentUser.UserId)
									.pipe(take(1))
									.subscribe(() => {
										this.refreshProductBarcodeMasterDataGrid();
									});
							}
						}
					]
				}
			);
		}
	}

	public barcodeMappingGridWithGlobalCompanyPrefixGridContextMenu(e) {
		if (e.target === 'content') {
			// e.items can be undefined
			if (!e.items) { e.items = []; }
			const rowData: BarcodeMappingGridWithGlobalCompanyPrefixModel = e.row.data;
			// Add a custom menu item
			e.items.push(
				{
					text: 'Refresh',
					icon: 'refresh',
					onItemClick: () => {
						this.refreshBarcodeMappingGridWithGlobalCompanyPrefixGrid();
					}
				},
				{
					text: 'Lookup for Barcode',
					disabled: !rowData.CleanBarcode,
					onItemClick: () => {
						this.lookupForBarcode(rowData.CleanBarcode);
					}
				},
				{
					text: 'Grid Settings',
					items: [
						{
							text: this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
							onItemClick: () => {
								this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting.autosave =
									!this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting.autosave;
								this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettings.Settings =
									JSON.stringify(this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSetting);
								this.updateGridSettings(this.barcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettings);
							}
						},
						{
							text: 'Reset to Default',
							onItemClick: () => {
								this.userService.resetDataGridStateToDefault(this.mappingGridName, this.pageName, this.currentUser.UserId)
									.pipe(take(1))
									.subscribe(() => {
										this.refreshBarcodeMappingGridWithGlobalCompanyPrefixGrid();
									});
							}
						}
					]
				}
			);
		}
	}

	private loaderHandler() {
		if (!this.isProductBarcodeMasterLoading &&
			!this.isBarcodeMappingGridWithGlobalCompanyPrefixGridLoading &&
			!this.isProductBarcodeMasterDataGridSettingLoading &&
			!this.isBarcodeMappingGridWithGlobalCompanyPrefixGridDataGridSettingLoading &&
			!this.isProductBarcodeAssignmentToMasterGridLoading) {
			this.loaderService.hide();
		}
	}

	formatFilterOperators(rawFilter: any[]) {
		if (!rawFilter) {
			return null;
		}
		const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
		return this.filterBuilder.filterFormatting(filterData);
	}

	private refreshProductBarcodeMasterDataGrid() {
		this.productBarcodeMasterCurrentPage = this.productBarcodeMasterGrid.instance.pageIndex();
		this.productBarcodeMasterGrid.instance.refresh();
	}

	private refreshBarcodeMappingGridWithGlobalCompanyPrefixGrid() {
		this.barcodeMappingGridWithGlobalCompanyPrefixGridCurrentPage = this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.pageIndex();
		this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.refresh();
	}

	ngOnDestroy() {
		this.dragulaService.destroy('HANDLES3');
		this.loaderService.hide();
		this._destroyed$.next(null);
		this._destroyed$.complete();
	}

	selectionProductBarcodeMasterChangedHandler() {
		if (this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.getSelectedRowsData()[0]) {
			this.productBarcodeMasterGridSelectedRowMap = this.productBarcodeMasterGrid.instance.getSelectedRowsData()[0];
		}
	}

	selectionBarcodeMappingGridWithGlobalCompanyPrefixGridChangedHandler() {
		if (this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.getSelectedRowsData()[0]) {
			this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap =
				this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.getSelectedRowsData()[0];
			this.getBarcodeMappingToMasterGridData
			(this.barcodeMappingGridWithGlobalCompanyPrefixGrid.instance.getSelectedRowsData()[0].BarcodeMappingId);
		}
	}

	public getBarcodeMappingToMasterGridData(BarcodeMappingId: number) {
		if (!BarcodeMappingId) {
			return;
		}
		this.isProductBarcodeAssignmentToMasterGridLoading = true;
		this.loaderService.show();
		this.productBarcodeService.getBarcodeMappingToMasterGridResult(BarcodeMappingId)
			.pipe(take(1))
			.subscribe((data) => {
				this.isProductBarcodeAssignmentToMasterGridLoading = false;
				this.loaderHandler();
				this.barcodeMappingToMasterGridDataSource = data;
				this.barcodeMappingToMasterGrid.instance.option('dataSource', data);
			});
	}

	private loadMasterColumnHeaderFilterData() {
		this.companyNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CompanyName';
				loadOptions.column = 'CompanyName';
				loadOptions.valueColumn = 'CompanyId';
				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});

		this.masterBrandHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'MasterBrandName';
				loadOptions.column = 'MasterBrandName';
				loadOptions.valueColumn = 'MasterBrandId';
				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});

		this.brandNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'BrandName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});

		this.subBrandNameHeaderDataSource =  new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubBrandName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});

		this.productNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});

		this.categoryNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				loadOptions.column = 'CategoryName';
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});

		this.subcategoryFunctionNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				loadOptions.column = 'SubcategoryFunctionName';
				loadOptions.valueColumn = '';

				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});

		this.subcategoryFormNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				loadOptions.column = 'SubcategoryFormName';
				loadOptions.valueColumn = '';

				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});

		this.productSizeOnLabelHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				loadOptions.column = 'ProductSizeOnLabel';
				loadOptions.valueColumn = '';

				return this.getHeaderFiltersProductMaster(loadOptions);
			}
		});
	}

	private getHeaderFiltersProductMaster(loadingOption) {
		return this.productBarcodeService.getProductBarcodeMasterGridHeaderFilters(loadingOption)
			.toPromise()
			.catch(error => { throw new Error('Data Loading Error'); });
	}

	omit(BarcodeMappingId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = BarcodeMappingId;
		mappingData.MappingModeId = MappingMode.Omitted;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Omit;
		this.actionHandler(mappingData, 'Omitted');
	}

	save(BarcodeMappingId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = BarcodeMappingId;
		mappingData.MappingModeId = MappingMode.Saved;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Save;
		this.actionHandler(mappingData, 'Saved');
	}

	map(BarcodeMappingId: any, ProductBarcodeId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.BarcodeMappingId;
		mappingData.ProductBarcodeId = ProductBarcodeId;
		mappingData.MappingModeId = MappingMode.Mapped;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Map;
		this.actionHandler(mappingData, 'Mapped');
	}

	accept(BarcodeMappingId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = BarcodeMappingId;
		mappingData.MappingModeId = MappingMode.Accepted;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Accept;
		this.actionHandler(mappingData, 'Accepted');
	}

	acceptMapping(BarcodeMappingId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = BarcodeMappingId;
		mappingData.MappingModeId = MappingMode.Accepted;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Accept;
		this.actionHandler(mappingData, 'Accepted');
	}

	review(BarcodeMappingId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = BarcodeMappingId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Review;
		this.actionHandler(mappingData, 'Reviewed');
	}

	deactivate(BarcodeMappingId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = BarcodeMappingId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Deactivate;
		this.actionHandler(mappingData, 'Deactivated');
	}

	reactivate(BarcodeMappingId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = BarcodeMappingId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Reactivate;
		this.actionHandler(mappingData, 'Reactivated');
	}

	private actionHandler(mappingData: ProductBarcodeMappingOption, message: string, refreshAll = false) {
		this.loaderService.show();
		return this.productBarcodeService.barcodeMappingAction(mappingData)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((res) => {
				this.refreshBarcodeMappingGridWithGlobalCompanyPrefixGrid();
				this.refreshProductBarcodeMasterDataGrid();
				if (res.State) {
					this.notificationService.show(`${message} successfully!`, NotificationType.Success);
				} else {
					this.notificationService.show('Something went wrong', NotificationType.Error);
				}
				this.loaderHandler();
			});
	}

	private reassignActionHandler(mappingData: ProductBarcodeMappingOption, message: string) {
		this.loaderService.show();
		return this.productBarcodeService.productBarcodeMappingAction(mappingData)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((res) => {
				this.refreshBarcodeMappingGridWithGlobalCompanyPrefixGrid();
				this.refreshProductBarcodeMasterDataGrid();
				if (res.State) {
					this.notificationService.show(`${message} successfully!`, NotificationType.Success);
				} else {
					this.notificationService.show('Something went wrong', NotificationType.Error);
				}
				this.loaderHandler();
			});
	}

	customizeBarcodeMappingId(cellInfo) {
		return cellInfo.value ? 'BcMp_' + cellInfo.value : null;
	}

	customizeBarcodeGlobalCompanyPrefixMappingId(cellInfo) {
		return cellInfo.value ? 'BcGcpMp_' + cellInfo.value : null;
	}

	customizeProductBarcodeId(cellInfo) {
		return cellInfo.value ? 'PBc_' + cellInfo.value : null;
	}

	customizeProductMasterId(cellInfo) {
		return cellInfo.value ? 'PMs_' + cellInfo.value : null;
	}

	customizeServiceAndProductMappingModeId(cellInfo) {
		return cellInfo.value ? cellInfo.value : null;
	}

	private async getHeaderFiltersBarcodeMapping(column) {
		try {
			return await this.productBarcodeService.getBarcodeMappingGridWithGlobalCompanyPrefixHeaderFilters (column)
				.toPromise ();
		} catch (error) {
			throw new Error ('Data Loading Error');
		}
	}

	private refreshBarcodeMappingToMasterGrid(BarcodeMappingId: any) {
		this.getBarcodeMappingToMasterGridData(BarcodeMappingId);
		this.barcodeMappingToMasterGrid.instance.refresh();
	}

	barcodeMappingToMasterGridContextMenu(e) {
		if (e.target === 'content') {
			// e.items can be undefined
			if (!e.items) { e.items = []; }
			const rowData = e.row.data;
			// Add a custom menu item
			e.items.push(
				{
					text: 'Refresh',
					icon: 'refresh',
					onItemClick: () => {
						this.refreshBarcodeMappingToMasterGrid(rowData.BarcodeMappingId);
					}
				},
				{
					text: 'Barcode Mapping',
					visible: (rowData.Ranking >= 0),
					items: [
						{
							text: 'Reassign Barcode',
							hint: 'Reassign Barcode',
							disabled: !(rowData.Ranking >= 0 &&
								rowData.IsInconsistentProductMapping &&
								rowData.ServiceAndProductMappingModeId === MappingMode.Mapped &&
								rowData.ProductBarcodeId !== 0 &&
								rowData.Barcode === this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.CleanBarcode &&
								rowData.ProductMasterId !== 0),
							onItemClick: () => {
								this.reassignBarcode(rowData.ProductMasterId, rowData.ProductBarcodeId);
							},
						},
					]
				}
			);
		}
	}

	isEligibleForProductBarcodeReassignment(rowData: BarcodeMappingToMasterGridModel) {
		if (rowData.Ranking >= 0 &&
			rowData.IsInconsistentProductMapping &&
			rowData.ServiceAndProductMappingModeId === MappingMode.Mapped &&
			rowData.ProductBarcodeId !== 0 &&
			rowData.Barcode === this.barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.CleanBarcode &&
			rowData.ProductMasterId !== 0) {
			return true;
		}
		return false;
	}

	private reassignBarcode(ProductMasterId: number, ProductBarcodeId: number) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.ProductMasterId = ProductMasterId;
		mappingData.ProductBarcodeId = ProductBarcodeId;
		mappingData.MappingModeId = MappingMode.ReAssigned;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.ReAssign;
		this.reassignActionHandler(mappingData, 'Re assigned');
	}

	omitMiddle(CurrentBarcodeMappingId) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = CurrentBarcodeMappingId;
		mappingData.MappingModeId = MappingMode.Omitted;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Omit;
		this.actionHandler(mappingData, 'Omitted');
	}

	saveMiddle(CurrentBarcodeMappingId) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = CurrentBarcodeMappingId;
		mappingData.MappingModeId = MappingMode.Saved;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Save;
		this.actionHandler(mappingData, 'Saved');
	}

	acceptMiddle(CurrentBarcodeMappingId) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = CurrentBarcodeMappingId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Accept;
		this.actionHandler(mappingData, 'Accepted');
	}

	reviewMiddle(CurrentBarcodeMappingId) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = CurrentBarcodeMappingId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Review;
		this.actionHandler(mappingData, 'Reviewed');
	}

	acceptMiddleMapping(CurrentBarcodeMappingId, ProductBarcodeId) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = CurrentBarcodeMappingId;
		mappingData.ProductBarcodeId = ProductBarcodeId;
		mappingData.MappingModeId = MappingMode.Mapped;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.AcceptMapping;
		this.actionHandler(mappingData, 'Mapping Accepted');
	}

	acceptOmitMiddle(CurrentBarcodeMappingId) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = CurrentBarcodeMappingId;
		mappingData.MappingModeId = MappingMode.Omitted;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Omit;
		this.actionHandler(mappingData, 'Omitted');
	}

	acceptSaveMiddle(CurrentBarcodeMappingId) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.BarcodeMappingId = CurrentBarcodeMappingId;
		mappingData.MappingModeId = MappingMode.Saved;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Save;
		this.actionHandler(mappingData, 'Saved');
	}

	private lookupForBarcode(CleanBarcode: string) {
		this.productBarcodeService.lookupBarcode(CleanBarcode);
	}
}
